export type ThemePreference = "light" | "dark" | null; // null = follow system
export type ThemeButton = "auto" | "light" | "dark";

export const THEME_STORAGE_KEY = "theme";

/** Pure transition: given the current stored preference and the button clicked,
 *  return the next preference. Mirrors ThemeUI in the legacy ui-main.js. */
export function nextPreference(
  current: ThemePreference,
  button: ThemeButton,
): ThemePreference {
  switch (button) {
    case "auto":
      return current ? null : "dark";
    case "light":
      return current !== "light" ? "light" : null;
    case "dark":
      return current !== "dark" ? "dark" : "light";
  }
}
